import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-alarms',
  standalone: true,
  templateUrl: './help-alarms.component.html',
  styleUrls: ['./help-alarms.component.css'],
})
export class HelpAlarmsComponent {
  readonly parent = input.required<HelpComponent>();
}
